<template>
  <v-app class="resume-container">
    <v-main>
      <router-view />
    </v-main>

    <!-- <base-footer/> -->
  </v-app>
</template>

<script>
// import { BaseFooter } from './components'
export default {
  name: 'Layout',
  components: {
    // BaseFooter
  }
}
</script>

<style scoped>
  .resume-container{
    background-color: #f8f8f8;
  }
</style>
